export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: { root: { wordBreak: 'break-word' } },
    },
  }
}
